// src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assests/branding/xtram/tokens.css';
import './assests/branding/xtram/responsive.css';
import { StrictMode } from 'react';
import App from './App';
import './Utils/fontSize';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider as ReduxProvider } from 'react-redux';
import { FontSizeProvider } from './Contexts/FontSizeContext';
import { store, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';

// Silence the harmless `ResizeObserver loop completed with undelivered
// notifications.` warning that CRA's react-error-overlay surfaces as a red
// error in development. It is a benign browser scheduling notice (commonly
// triggered by MUI's `TextareaAutosize` / `Autocomplete` components) and is
// safe to ignore. We listen as early as possible so the overlay never sees it.
// References: facebook/create-react-app#11334, mui/material-ui#36909.
const RESIZE_OBSERVER_ERROR_RE = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
const swallowResizeObserverError = (event) => {
    const message = event?.message || event?.reason?.message || '';
    if (RESIZE_OBSERVER_ERROR_RE.test(message)) {
        if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
        }
        if (typeof event.preventDefault === 'function') {
            event.preventDefault();
        }
        return false;
    }
    return undefined;
};
if (typeof window !== 'undefined') {
    window.addEventListener('error', swallowResizeObserverError);
    window.addEventListener('unhandledrejection', swallowResizeObserverError);
}

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ReduxProvider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <FontSizeProvider>
            <App />
          </FontSizeProvider>
        </PersistGate>
      </ReduxProvider>
    </QueryClientProvider>
  </StrictMode>
);

reportWebVitals();
